// @uifabric/example-app-base@6.23.7
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
import { setVersion } from '@uifabric/set-version';
setVersion('@uifabric/example-app-base', '6.23.7');